/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
  useRef
} from 'react'

import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import Lottie from "lottie-react";
import { QRCodeSVG } from 'qrcode.react';
import Countdown, { zeroPad } from 'react-countdown';

import {
  toAbsoluteUrl
} from '../../../_metronic/helpers'

import LoadingContent from '../../modules/loading/LoadingContent'
import waitPaymentCard from '../../../_metronic/assets/animations/waitPaymentCard.json';
import waitPaymentWords from '../../../_metronic/assets/animations/waitPaymentWords.json';
import paymentAnimation  from '../../../_metronic/assets/animations/payment.json';
import paymentRejectedAnimation  from '../../../_metronic/assets/animations/paymentRejected.json';
import waitPaymentPix  from '../../../_metronic/assets/animations/waitPaymentPix.json';

import { CancelSchedule } from './CancelSchedule';
import SupportOption from 'app/pages/HelpCenter/SupportOption';
import SelectPayment from 'app/pages/Payment/components/SelectPayment';

import {
  fetchSchedule,
  fetchCancelSchedule,
} from 'app/services/schedules'

import {
  fetchUpdatePaymentMethod,
} from 'app/services/payments';

import {
  formatLongDateTime,
  calculateDiffMinutes,
} from 'app/services/dates'

import useInterval from "app/utils/useInterval";

import {
  getBrandImage,
} from "app/utils/Labels";

import {
  formatMoney,
} from 'app/services/intFormat';

const Schedule = () => {
  const { auth,  payments, schedules } = useSelector((state : any) => ({
    auth: state.auth,
    payments: state.payments,
    schedules: state.schedules,
  }), shallowEqual);

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [schedule, setSchedule] = useState<any>({});
  const [invoice, setInvoice] = useState<any>({});
  const [invoices, setInvoices] = useState<any>([]);
  const [payment, setPayment] = useState<any>({});
  const [updatePayment, setUpdatePayment] = useState<any>({});

  const [waitingProcessPayment, setWaitingProcessPayment] = useState(false);
  const [waitingPixPayment, setWaitingPixPayment] = useState(false);
  const [rejectPayment, setRejectPayment] = useState(false);

  const [copied, setCopied] = useState(false);

  const [openDeleteSchedule, setOpenDeleteSchedule] = useState<any>(false);

  const lottieRef = useRef<any>();

  useEffect(() => {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-open' }))
    }
    return () => {
      if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-close' }))
      }
    }
  }, []);

  useEffect(() => {
    setSchedule({});
    setInvoices([]);
    setInvoice({});
    setPayment({});

    setWaitingProcessPayment(false);
    setWaitingPixPayment(false);
    setRejectPayment(false);

    getSchedule();
  }, []);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  useEffect(() => {
    if (schedule?.id) {
      let currentInvoice = {};

      if (schedule.relationships.invoices.length == 1) {
        currentInvoice = schedule.relationships.invoices[0];
      } else {
        currentInvoice = schedule.relationships.invoices.find((value) => value.attributes.is_current == true);
      }

      setInvoice(currentInvoice);
      setInvoices(schedule.relationships.invoices);
    }
  }, [schedule]);

  useInterval(() => {
    checkPayment();
  }, 2000);

  useEffect(() => {
    if (invoice && invoice.id) {
      if (invoice.relationships.payments && invoice.relationships.payments[0] && invoice.relationships.payments[0].id) {
        let firstPayment = invoice.relationships.payments[0];
        setPayment(firstPayment);

        if (firstPayment.attributes.type == 'pix' && firstPayment.attributes.is_pending && !invoice.attributes.is_canceled) {
          if (firstPayment.attributes.pix_qrcode) {
            setWaitingProcessPayment(false);
            setWaitingPixPayment(true);
            setRejectPayment(false);
          }

          if (!firstPayment.attributes.pix_qrcode) {
            setWaitingProcessPayment(true);
            setWaitingPixPayment(false);
            setRejectPayment(false);
          }
        }

        if (firstPayment.attributes.type == 'credit_card' && firstPayment.attributes.is_pending) {
          setWaitingProcessPayment(true);
          setWaitingPixPayment(false);
          setRejectPayment(false);
        }

        if (firstPayment.attributes.is_failed && (invoice.attributes.is_pending || invoice.attributes.is_expired)) {
          setWaitingProcessPayment(false);
          setWaitingPixPayment(false);
          setRejectPayment(true);
        }

        if (firstPayment.attributes.is_paid || (invoice.attributes.is_canceled)) {
          setWaitingProcessPayment(false);
          setWaitingPixPayment(false);
          setRejectPayment(false);
        }
      }
    }
  }, [invoice]);

  const checkPayment = () => {
    if (invoice && invoice?.id) {
      if (invoice?.attributes?.payment_type == 'online' && (invoice?.attributes?.is_pending || invoice?.attributes?.is_expired)) {
        verifyScheduleStatusChanged();
      }
    }
  }

  const cancel = (value = '') => {
    if (schedule.id) {
      dispatch<any>(fetchCancelSchedule(schedule.id, value)).then((response: any) => {
        setOpenDeleteSchedule(false);

        navigate('/compras/locacao-de-quadra');
      });
    }
  }

  const getSchedule = () => {
    dispatch<any>(fetchSchedule(id)).then(response => {
      setSchedule(response);
    }).catch((error) => {
      navigate('/compras/locacao-de-quadra');
    });
  }

  const verifyScheduleStatusChanged = () => {
    dispatch<any>(fetchSchedule(id)).then(response => {
      let currentInvoice: any = {};

      if (response.relationships.invoices.length == 1) {
        currentInvoice = response.relationships.invoices[0];
      } else {
        currentInvoice = response.relationships.invoices.find((value) => value.attributes.is_current == true);
      }

      if (
        (currentInvoice?.relationships?.status.id != invoice?.relationships.status.id) ||
        (currentInvoice?.relationships?.payments[0].attributes.status_id != payment?.attributes?.status_id) ||
        (currentInvoice?.relationships?.payments[0].attributes.pix_qrcode != payment?.attributes?.pix_qrcode)
      ) {
        setSchedule(response);
      }
    });
  }

  const getPaymentMethod = () => {
    if (invoice?.attributes) {
      let paymentMethod = invoice.attributes.payment_method;

      if (paymentMethod == 'credit') {
        return `Consumo de crédito`;
      }

      if (paymentMethod == 'pix') {
        return <div className="flex-column">
            <img src={toAbsoluteUrl('/media/custom/pix.png')} width="25" alt='Pix' />
            <span className="ms-3">PIX</span>
          </div>
      }

      if (paymentMethod == 'credit_card') {
        if (invoice.relationships.payments &&
          invoice.relationships.payments[0] &&
          invoice.relationships.payments[0].relationships &&
          invoice.relationships.payments[0].relationships.client_card &&
          invoice.relationships.payments[0].relationships.client_card.attributes
        ) {
          return <div className="flex-column">
            <img src={toAbsoluteUrl(`/media/custom/${getBrandImage(invoice.relationships.payments[0].relationships.client_card.attributes.brand)}`)} width="25" alt='Pix' />
            <span className="ms-3"> ••• {invoice?.relationships?.payments[0].relationships.client_card.attributes.last_four_digits}</span>
          </div>
        }
      }
    }

    return '-';
  }

  const copyPixLink = (value) => {
    navigator.clipboard.writeText(value);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }

  const updatePaymentMethod = () => {
    let paymentMethod = updatePayment.paymentMethod;
    let cardId = updatePayment.paymentMethod == 'credit_card' && updatePayment.card && updatePayment.card.id;

    dispatch<any>(fetchUpdatePaymentMethod(payment.id, paymentMethod, cardId)).then(response => {
      getSchedule();
    }).catch((error) => {
      getSchedule();
    });
  }

  return (
    <>
    <div id="kt_app_content" className="flex-column-fluid">
      <span className="btn btn-md btn-icon btn-bg-light btn-active-color-primary w-100px h-40px cursor-pointer mb-5" onClick={() => navigate('/compras/locacao-de-quadra')}>
        <i className="las la-arrow-left fw-bold fs-2 text-primary me-3" />
        Voltar
      </span>
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-lg-row-fluid mb-5 mb-lg-0">
          <div className='card mb-5 mb-sm-0'>
            <div className='card-body pt-5'>
              <div className="justify-content-space-between d-flex mb-5">
                <span className="flex-root text-center fs-2 fw-bold">
                  {!waitingProcessPayment ? "Detalhes da compra" : "Processando o pagamento"}
                </span>
              </div>
              <div className="row mt-10">
                {waitingProcessPayment && <>
                  <div className="col-md-8 offset-md-2">
                    <Lottie
                      style={{
                        width: '100%',
                        height: 250,
                      }}
                      animationData={waitPaymentCard}
                      loop
                      autoplay
                    />
                    <Lottie
                      style={{
                        width: '100%',
                        height: 90,
                      }}
                      animationData={waitPaymentWords}
                      loop
                      autoplay
                    />
                  </div>
                </>}

                {!waitingProcessPayment && rejectPayment && <>
                  <div className="col-md-10 offset-md-1">
                    <Lottie
                      style={{
                        width: '100%',
                        height: 125,
                      }}
                      lottieRef={lottieRef}
                      animationData={paymentRejectedAnimation}
                      loop={false}
                      onDOMLoaded={() => lottieRef.current?.setSpeed(1.4)}
                      autoplay
                    />

                    <div className="justify-content-space-between d-flex mb-5">
                      <span className="flex-root text-center fs-5 text-white fw-bold">
                        Pagamento recusado
                      </span>
                    </div>
                    <div className="justify-content-space-between d-flex mb-5">
                      <span className="flex-root text-center fs-5 text-gray-800">
                        Você pode escolher outro meio de pagamento ou cadastrar um novo cartão
                      </span>
                    </div>

                    <div className="fv-row mb-5">
                      <SelectPayment
                        type={"schedule"}
                        onSelect={(value) => setUpdatePayment(value)}
                        disableCredit={true}
                        paymentMethod={"update"}
                      />
                    </div>

                    <div className="separator mx-0"></div>

                    <div className="fv-row">
                      <div className="d-flex justify-content-center py-5">
                        <button
                          type="button"
                          className="btn btn-lg fw-bold btn-primary w-100 w-md-50"
                          onClick={() => updatePaymentMethod()}
                          disabled={payments.listLoading}
                        >
                          {!payments.listLoading && <span className="indicator-label">REFAZER PAGAMENTO</span>}
                          {payments.listLoading && <span className="indicator-label">
                            Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>}
                        </button>
                      </div>
                    </div>

                    <div className="d-flex flex-column mb-0 align-items-center">
                      <span className="flex-root text-center fs-6 text-gray-700">
                        Você tem até <span className="fw-bold text-primary">15 minutos</span> para fazer o pagamento.
                      </span>
                      <span className="flex-root text-center fs-6 text-gray-700">
                        O tempo para você pagar acaba em:
                      </span>
                      <Countdown
                        date={payment.attributes.expired_at_iso}
                        renderer={({ total, minutes, seconds }) => {
                          return <span className={`flex-root fs-1 fw-bold ${total > 120000 ? "text-white" : 'text-danger'}`}>
                            {zeroPad(minutes)}:{zeroPad(seconds)}
                          </span>
                        }}
                      />
                    </div>
                  </div>
                </>}

                {!waitingProcessPayment && waitingPixPayment && <>
                  <div className="col-md-10 offset-md-1">
                    <Lottie
                      style={{
                        width: '100%',
                        height: 150,
                      }}
                      animationData={waitPaymentPix}
                      loop={false}
                      autoplay
                    />
                    <div className="justify-content-space-between d-flex mb-5">
                      <span className="flex-root text-center fs-5 text-white fw-bold">
                        Estamos aguardando seu pagamento
                      </span>
                    </div>
                    <div className="justify-content-space-between d-flex mb-5">
                      <span className="flex-root text-center fs-5 text-gray-800">
                        Pague via QR Code ou copie o código abaixo e utilize o Pix Copia e Cola no aplicativo que você vai fazer o pagamento:
                      </span>
                    </div>
                    <div className="justify-content-center d-flex mb-5">
                      <div className="card bg-white p-5 align-items-center w-170px">
                        <QRCodeSVG value={payment.attributes.pix_qrcode} width={160} height={160} />
                      </div>
                    </div>

                    <div className="justify-content-center d-flex mb-5 flex-column flex-md-row">
                      <input
                        type="text"
                        readOnly={true}
                        className={"form-control form-control-solid me-3 flex-grow-1" + (copied == true && " border-success text-inverse-success")}
                        name="pix_copia_cola"
                        value={payment.attributes.pix_qrcode}
                      />
                      <button
                        type="button"
                        className="btn btn-light fw-bold flex-shrink-0 w-100 w-md-50 w-md-150px mt-5 mt-md-0"
                        onClick={() => copyPixLink(payment.attributes.pix_qrcode)}
                      >
                        {copied == false ? 'Copiar código' : 'Copiado!'}
                      </button>
                    </div>

                    <div className="d-flex flex-column mb-5 align-items-center">
                      <span className="flex-root text-center fs-6 text-gray-700">
                        Você tem até <span className="fw-bold text-primary">15 minutos</span> para fazer o pagamento.
                      </span>
                      <span className="flex-root text-center fs-6 text-gray-700">
                        O tempo para você pagar acaba em:
                      </span>
                      <Countdown
                        date={payment.attributes.expired_at_iso}
                        renderer={({ total, minutes, seconds }) => {
                          return <span className={`flex-root fs-1 fw-bold ${total > 120000 ? "text-white" : 'text-danger'}`}>
                            {zeroPad(minutes)}:{zeroPad(seconds)}
                          </span>
                        }}
                      />
                    </div>
                  </div>
                </>}

                {!waitingProcessPayment && schedule?.relationships?.status.attributes.name == 'confirmed'  && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 50,
                            height: 50,
                          }}
                          animationData={paymentAnimation}
                          loop={false}
                          autoplay
                          rendererSettings={{
                            preserveAspectRatio: 'xMidYMid slice',
                          }}
                          initialSegment={[0,22]}
                        />
                        <div className="fs-5 opacity-75 fw-bold px-3">
                          {schedule.attributes.past ? "Agendamento concluído" : "Agendamento confirmado"}
                        </div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      {schedule.attributes.past ?
                        "Seu agendamento foi confirmado e realizado no campo, avalie como seu jogo." :
                        "Seu agendamento está confirmado com o campo. Agora é só jogar!"}
                    </div>
                  </div>
                </div>}

                {
                  !waitingProcessPayment &&
                  schedule?.relationships?.status.attributes.name == 'pending' &&
                  (invoice?.attributes?.payment_type == 'locally' || invoice?.attributes?.payment_method == 'credit') && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                    <div className="flex-root justify-content-center text-center">
                      <div className="card border border-1 bg-warning p-3 w-100">
                        <div className="d-flex flex-stack justify-content-center text-center me-2">
                          <div className="fs-5 text-gray-100 fw-bold">Aguardando aprovação do campo</div>
                        </div>
                      </div>
                      <div className="fs-6 opacity-50 mt-5">O campo foi notificado sobre seu agendamento e estamos aguardando a resposta do campo.</div>
                      <div className="fs-6 opacity-50 mt-3">Aprovação do campo demora no máximo 1 hora durante o horário de funcionamento do campo.</div>
                    </div>
                  </div>
                }

                {!waitingProcessPayment && schedule?.relationships?.status.attributes.name == 'canceled' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 p-3 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          lottieRef={lottieRef}
                          animationData={paymentRejectedAnimation}
                          loop={false}
                          onDOMLoaded={() => lottieRef.current?.setSpeed(1.4)}
                          autoplay
                        />

                        <div className="fs-5 opacity-75 fw-bold px-3">Agendamento cancelado</div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      {(
                        invoice?.attributes?.payment_type == 'online' &&
                        invoice?.attributes?.payment_method == 'pix'
                      ) && `Fique tranquilo, seu pagamento foi estornado`}

                      {(
                        invoice?.attributes?.payment_type == 'online' &&
                        invoice?.attributes?.payment_method == 'credit_card'
                      ) && `Fique tranquilo, seu pagamento será reembolsado nas próximas faturas`}

                      {(
                        invoice?.attributes?.payment_type == 'online' &&
                        invoice?.attributes?.payment_method == 'credit'
                      ) && `Fique tranquilo, seu crédito foi estornado`}
                    </div>
                  </div>
                </div>}
              </div>
              {schedule?.id && <div className="row mt-5">
                <div className="col-lg-12">
                  <div className="justify-content-space-between d-flex mb-2">
                    <span className="flex-root fs-3 fw-bold text-primary">
                      Informações
                    </span>
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='border-0'>
                          <th className='p-0 w-140px'></th>
                          <th className='p-0 min-w-140px'></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Serviço
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{schedule.relationships.service.attributes.name}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Quando
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{formatLongDateTime(schedule.attributes.start_at)} •  {calculateDiffMinutes(schedule.attributes.start_at, schedule.attributes.finish_at) + ' min'}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Unidade
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{schedule.relationships.field.relationships.branch.attributes.name}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Quadra
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{schedule.relationships.field.attributes.name}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-muted fw-bold mb-1 fs-6'>
                              Tipo de quadra
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>{schedule.relationships.field.attributes.groundTypeLabel}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}

              {schedules.listLoading === false && !schedule?.id && <div className="mb-13 text-center">
                <h2 className="mb-3">
                  Ops, agendamento não encontrado!
                </h2>
                <div className="text-muted fw-semibold fs-5">
                  Não encontramos a página que você procura!
                </div>
                <div className="text-muted fw-semibold fs-5">
                  Verifique a url ou tente novamente.
                </div>
              </div>}

              {(schedules.listLoading === true) && !schedule?.id && <LoadingContent />}
            </div>
          </div>
        </div>

        <div className="flex-lg-auto min-w-lg-400px ms-lg-10">
          <div className='card mb-5'>
            <div className='card-body pt-5 pb-0 mb-5'>
              {schedule?.id && <>
                <div className="mb-5 text-center">
                  <span className="flex-root text-center fs-2 fw-bold mb-3">
                    Pagamento
                  </span>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Resumo de valores
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                        <thead>
                          <tr className='border-0'>
                            <th className='p-0 w-140px'></th>
                            <th className='p-0 min-w-140px'></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span className='text-muted fw-bold mb-1 fs-6'>
                                {invoice.attributes?.payment_type == 'online' && `Pagamento pelo app`}
                                {invoice.attributes?.payment_type == 'locally' &&  `Forma de pagamento`}
                              </span>
                            </td>
                            <td className='text-end text-dark fw-semibold'>
                              {invoice.attributes?.payment_type == 'online' && getPaymentMethod()}
                              {invoice.attributes?.payment_type == 'locally' &&  `Efetuado na unidade`}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span className='fs-3 text-white fw-bold mb-1 fs-6'>
                                Total
                              </span>
                            </td>
                            <td className='fs-3 text-end text-primary fw-bold'>
                              {invoice?.attributes?.payment_type == 'online' && invoice?.attributes?.payment_method == 'credit' && <span>
                                1 Crédito
                              </span>}

                              {!(invoice?.attributes?.payment_type == 'online' && invoice?.attributes?.payment_method == 'credit') && <>
                                {invoice?.attributes?.price && invoice?.attributes?.price != invoice?.attributes?.full_price && <span className="fs-7 text-gray-700 lineThrough me-2">
                                  {formatMoney(invoice?.attributes?.price)}
                                </span>}

                                <span>
                                  {formatMoney(invoice?.attributes?.full_price)}
                                </span>
                              </>}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Precisa de ajuda?
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <SupportOption
                        originType={'schedule'}
                        originId={schedule && schedule.id}
                        canCancel={schedule.attributes && schedule.attributes.can_cancel == true && schedule.relationships.status.attributes.name != 'canceled'}
                        cancelTitle={'Quero cancelar essa compra'}
                        phone={schedule.relationships?.field?.relationships?.branch?.attributes?.phone}
                        cancel={() => setOpenDeleteSchedule(true)}
                      />
                    </div>
                  </div>
                </div>
              </>}
            </div>
          </div>
        </div>
      </div>
    </div>

    <CancelSchedule
      isOpen={openDeleteSchedule}
      onClosed={() => setOpenDeleteSchedule(false)}
      withCredit={schedule?.attributes?.can_cancel_with_credit}
      withPayment={schedule?.attributes?.can_cancel_with_payment}
      creditLimitWeekday={schedule?.attributes?.credit_restriction?.weekday_bitmask}
      creditLimitStartAt={schedule?.attributes?.credit_restriction?.start_minutes}
      creditLimitEndAt={schedule?.attributes?.credit_restriction?.end_minutes}
      onChange={(value) => cancel(value)}
      isLoading={false}
    />
  </>)
}

export {
  Schedule
}
